import styled from 'vue-styled-components'

const disabledBgc = props => props.disabled ? '#ddd' : '#fafafa'
const bgc = props => props.blue ? '#4771F3' : disabledBgc(props)

const disabledColor = props => props.disabled ? '#888' : '#212121'
const color = props => props.blue ? '#fff' : disabledColor(props)

export default styled('button', { blue: Boolean, disabled: Boolean })`
    font-family: 'Montserrat', sans-serif;
    border: 0;
    border-radius: 4px;
    font-weight: 400;
    padding: 0px 12px;
    font-size: 14px;
    background-origin: border-box;
    border: 1px solid #4771F3;
    line-height: 32px;
    background-color: ${bgc};
    color: ${color};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    box-shadow: 1px 1px 2px gray;
    &:hover: {
        border: 1px solid rgba(0,0,0,.5);
    }
    &:active {
        transform: ${props => !props.disabled ? 'translate(1px, 1px)' : '0'};
        box-shadow: ${props => !props.disabled ? '0 0 2px gray' : '0'};
    }
`